const ENV = "dev";
export const RAZORPAY_KEY = "rzp_test_PrYFlV8L1wbhre";

export const CAMERA_INTEGRITY_ENABLED = true;

export default ENV;
